import { GEO_SEARCH_TIMEOUT_MESSAGE } from "./geoSearchTimeout";

// Geo API error mapping — feature-local, no Redux.

export function geoMessageFromError(err) {
  if (!err) return "Помилка з'єднання.";
  if (err.code === "GEO_SEARCH_TIMEOUT" || err.name === "GeoSearchTimeoutError") {
    return GEO_SEARCH_TIMEOUT_MESSAGE;
  }
  const status = err.response?.status;
  if (status === 429) {
    return "Забагато запитів. Спробуйте трохи пізніше.";
  }
  if (status === 400 || status === 404) {
    const data = err.response?.data;
    if (typeof data === "string") return data;
    if (typeof data?.detail === "string") return data.detail;
  }
  if (err.message && typeof err.message === "string") return err.message;
  return "Помилка з'єднання.";
}
